import PerfectScrollbar from 'perfect-scrollbar';

export const InitScrollBars = () => {
    const scrollbleBlocks = Array.from(document.querySelectorAll('.js-scrollbar-block'));

    scrollbleBlocks.forEach((block) => {
        // eslint-disable-next-line no-new
        new PerfectScrollbar(block, {
            suppressScrollX: true,
            scrollingThreshold: 5
        });
    });
};
